import styled from "styled-components";
import FlexBox from "./FlexBox";
import { H2 } from "./Headings";
import { ERROR_RED_400 } from "./colors";

const Container = styled(FlexBox)`
  height: 100vh;
  width: 100vw;
  padding: 1rem;
  align-items: center;
  justify-content: center;
`;

const MobileFullScreenError = ({ error }) => {
  return (
    <Container>
      <H2 bold color={ERROR_RED_400} wordBreak="break-all">
        {error}
      </H2>
    </Container>
  );
};

export default MobileFullScreenError;
